<div class="wrapper">
  <!-- header -->
  <div class="row div-header">
    <div class="col-lg-8 col-md-6 col-sm-6 col-4">
      <a href="https://www.orion-veicolispeciali.info"><img src="https://orion-veicolispeciali.info/it/wp-content/uploads/2018/03/LogoORION.png" class="logo"></a>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-6 col-8 contattaci-container">
      <button class="btn btn-outline-primary contattaci btn-orion float-right" (click)="openContatti()"><i class="fas fa-2x fa-envelope"></i> <br>CONTATTACI</button>
      <button class="btn btn-outline-primary contattaci btn-orion float-right" (click)="login()" *ngIf="!loggato"><i class="fas fa-2x fa-unlock-alt"></i> <br>LOGIN</button>
      <button class="btn btn-outline-primary contattaci btn-orion float-right" (click)="logout()" *ngIf="loggato"><i class="fas fa-2x fa-key"></i> <br>LOGOUT</button>
      <a href="home" class="btn btn-outline-primary contattaci btn-orion float-right"><i class="fas fa-2x fa-home"></i> <br>HOME</a>
    </div>

  </div>
  <div class="row" style="margin-top: 140px; z-index: 0; margin-left: 0; margin-right: 0;">
    <div class="col-lg-12">
      <router-outlet></router-outlet>
    </div>
  </div>
  
  <app-footer></app-footer>
</div>



<div class="modal-outer-div" *ngIf="modalLogin">
  <div class="modal-inner-div">
    <div class="modal-header" style="background-color: rgba(0, 0, 0, 0.03);">
      <h4 class="modal-title">Login</h4>
      <button type="button" class="close"  aria-label="Close" (click)="closeLogin()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-10">
          <label>Password</label>
          <input type="password" class="form-control" [(ngModel)]="password">
        </div>
        <div class="col-lg-2">
          <button class="btn btn-success btn-ricerca float-right" (click)="entra()">Entra</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-outer-div" *ngIf="modalContatti">
  <div class="modal-inner-div">
    <div class="modal-header" style="background-color: rgba(0, 0, 0, 0.03);">
      <h4 class="modal-title">Contattaci</h4>
      <button type="button" class="close"  aria-label="Close" (click)="closeContatti()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-6">
          <label>Nome e cognome</label>
          <input class="form-control" [(ngModel)]="nome">
        </div>
        <div class="col-lg-6">
          <label>Associazione</label>
          <input class="form-control" [(ngModel)]="associazione">
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <label>Numero di telefono</label>
          <input class="form-control" [(ngModel)]="telefono">
        </div>
        <div class="col-lg-6">
          <label>E-mail</label>
          <input class="form-control" [(ngModel)]="mail">
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12" style="padding-right: 15px; padding-left: 15px;">
          <label>Provincia</label>
          <select class="form-control" [(ngModel)]="provincia">
            <option *ngFor="let a of province" [value]="a._id">{{a.nome}} ({{a.sigla}})</option>  <!-- {{a[val]}} -  -->
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12" style="padding-right: 15px; padding-left: 15px;">
          <label>Nota</label>
          <textarea rows="4" class="form-control" [(ngModel)]="nota"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-10">
          <br>
          <re-captcha (resolved)="resolved($event)" siteKey="6LcB1V4UAAAAAJUC1vzausbOC7FFsD0-HnfYKmpj"></re-captcha>
        </div>
        <div class="col-lg-2">
          <br>
          <button class="btn btn-success btn-ricerca float-right" (click)="invioContatto()">Contattaci</button>
        </div>
      </div>
    </div>
  </div>
</div>
